// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"styles_breadcrumbs__3pzcK","link":"styles_link__10_IK","item":"styles_item__Qs7sz","lastItem":"styles_lastItem__DScVS","separator":"styles_separator__Lgv2c"};